import { updateName } from './update-name.js'

export function addListenersNaming (DOMelement, browserAppAccount) {
  if (!DOMelement) return

  // Enable renaming
  DOMelement.addEventListener('click', function (clickEvent) {
    const clickedElement = clickEvent.target.closest('#renameAccount')
    if (!clickedElement) return

    console.log('event to rename')
    showRenamingForm()
  })

  // Cancel renaming
  DOMelement.addEventListener('click', function (clickEvent) {
    const clickedElement = clickEvent.target.closest('#renamingCancel')
    if (!clickedElement) return

    hideRenamingForm()
  })

  // Submit renaming
  DOMelement.addEventListener('click', function (clickEvent) {
    const clickedElement = clickEvent.target.closest('#renamingSubmit')
    if (!clickedElement) return

    updateName({ browserAppAccount })
  })
}

export function showRenamingForm () {
  const renamingFormElement = document.getElementById('renamingForm')
  if (!renamingFormElement) return

  renamingFormElement.classList.remove('is-hidden')

  const nameInfoElements = document.querySelectorAll('.nameInfo')
  nameInfoElements.forEach(function (oneElement) {
    oneElement.classList.add('is-hidden')
  })
}

export function hideRenamingForm () {
  const renamingFormElement = document.getElementById('renamingForm')
  if (!renamingFormElement) return

  renamingFormElement.classList.add('is-hidden')

  const nameInfoElements = document.querySelectorAll('.nameInfo')
  nameInfoElements.forEach(function (oneElement) {
    oneElement.classList.remove('is-hidden')
  })
}
